module.exports = __webpack_public_path__ + "static/work50-c6c8a4f5037ce4670fe58ab59bd43226.jpg";